export default __webpack_public_path__ + "static/media/plan600.8abe5130.svg";